const baseURL = process.env.API_URL;
console.log(`baseURL: ${baseURL}`);
export const REST_URL = (() => {
    if (process.env.NODE_ENV === "development") {
        return new URL(baseURL);
    }
    if (process.env.NODE_ENV === "production") {
        let currentUrl = new URL(window.location.href);
        return new URL(baseURL, currentUrl.origin);
    }
})();
if (window.location.href.startsWith("https")) {
    REST_URL.protocol = "https";
}
console.log(`REST_URL: ${REST_URL}`);

// export const MAX_CANVAS_SIZE = 16000;
export const MAX_CANVAS_WIDTH = 16384;
export const MAX_CANVAS_HEIGHT = 16384;
export const MIN_CANVAS_WIDTH = 10;
export const MIN_CANVAS_HEIGHT = 10;
export const SCHEDULE_URL = new URL("investigation/schedule-task", REST_URL);
export const STATUS_URL = new URL("investigation/status-task", REST_URL);
export const OBTAIL_URL = new URL("token/obtain", REST_URL);
export const LICENSE_URL = new URL("license/check_license", REST_URL);
// export const OBTAIL_URL = new URL("http://10.10.35.138/");

export const REFRESH_URL = new URL("token/refresh", REST_URL);
export const IDENTIFY_URL = new URL("investigation/identify-mark", REST_URL);
export const STATS_URL = new URL("investigation/get-stats", REST_URL);
export const CANCEL_URL = new URL("investigation/cancel-task", REST_URL);
export const GET_IMAGE_URL = new URL("investigation/get-image", REST_URL);
export const SUBSCRIBE_URL = new URL(
    "investigation/subscribe-to-progress",
    REST_URL
);
export const CHECK_PRESENCE_URL = new URL(
    "investigation/check-marks-presence",
    REST_URL
);

SUBSCRIBE_URL.protocol = window.location.href.startsWith("https")
    ? "wss"
    : "ws";
